<script lang="ts" setup>
defineOptions({
    name: 'ActionBar',
    components: {
        Vnodes: (props: Record<string, any>, context: any) => props.vnodes
    }
});

const slots = useSlots() as any;
const { mobile } = useMedia();

const props = withDefaults(defineProps<{
    breakpoint?: boolean;
    headerTitle?: string;
    headerIcon?: string;
    autoHeader?: boolean;
    toggleFooter?: boolean;
    toggleHeader?: boolean;
}>(), {
    breakpoint: undefined,
    headerTitle: '',
    headerIcon: ''
});

const dropdown = ref(false);
const floating = ref(false);

const condition = computed((): boolean =>
{
    if (props.breakpoint !== undefined)
        return props.breakpoint;
    else
        return mobile();
});

const all = (): any[] =>
{
    return slots.default().filter((p: any) => p.type.name === 'ActionButton');
};

const toolbar = (): any[] =>
{
    return all().filter((p: any) => p.props.toolbar !== undefined && p.props.toolbar !== false);
};

const back = (): any[] =>
{
    return all().filter((p: any) => p.props.back !== undefined && p.props.back !== false);
};

const firstToolbar = (): any[] =>
{
    const items = toolbar();

    return items.length > 0 ? [items[0]] : [];
};

const otherToolbar = (): any[] =>
{
    return toolbar().slice(1);
};

const firstToolbarClass = (): string =>
{
    return `btn btn-${firstToolbar()[0].props.variant}`;
};

const firstBack = (): any[] =>
{
    const items = back();

    return items.length > 0 ? [items[0]] : [];
};

const other = (): any[] =>
{
    const toolbarItems = toolbar();
    const backItems = firstBack();

    return all().filter((p: any) => !toolbarItems.includes(p) && !backItems.includes(p));
};
</script>

<template>
    <div :class="{ 'action-bar d-flex px-3': condition && (back().length > 0 || toolbar().length > 0) }">
        <slot v-if="!condition" name="default" />
        <div v-if="condition" class="flex-fill d-flex align-items-center">
            <div v-if="back().length > 0">
                <Vnodes :vnodes="firstBack()" />
            </div>
            <div class="flex-fill">
                <ActionHeader :auto-header="autoHeader" :header-title="headerTitle" :header-icon="headerIcon" />
            </div>
            <div>
                <Vnodes v-if="toolbar().length == 1" :vnodes="firstToolbar()" />
                <div v-if="toolbar().length > 1" class="dropdown btn-group d-block" :class="{ 'show': dropdown }">
                    <Vnodes :vnodes="firstToolbar()" />
                    <button type="button" class="dropdown-toggle dropdown-toggle-split" :class="firstToolbarClass()" @click="dropdown = !dropdown" />
                    <div class="dropdown-menu dropdown-menu-right" :class="{ 'show': dropdown }">
                        <Vnodes :vnodes="otherToolbar()" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="condition && other().length == 1" class="floating rounded-pill shadow">
            <Vnodes :vnodes="other()" />
        </div>
        <div v-if="condition && other().length > 1" class="floating rounded-pill shadow btn-group dropup" :class="{ 'show': floating }">
            <ActionButton icon="fas fa-ellipsis-v" variant="dark" @click="floating = !floating" />
            <div class="dropdown-menu dropdown-menu-right" :class="{ 'show': floating }">
                <Vnodes :vnodes="other()" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.floating {
    position: fixed;
    right: 15px;
    bottom: 10px;
    z-index: 10002;

    &.dropup {
        .dropdown-menu {
            top: auto;
            bottom: 100%;
            margin-top: 0;
            margin-bottom: 0.125rem;
        }
    }
}

.dropdown-menu-right {
    right: 0;
    left: auto;
}

.action-bar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    min-width: var(--ideo-app-min-width);
    min-height: calc(var(--ideo-header-height) - 2px);
    padding: 10px 0;
    background-color: var(--bs-white);
    border-top: none;
    z-index: 99;

    .dropdown-menu {
        z-index: 9999;
    }

    .dropdown-toggle-split {
        &::before {
            box-shadow: none !important;
        }
    }
}
</style>
